import React from 'react';
import SearchTab from './SearchTab';
import VideoDetail from './VideoDetail';
import youtube from '../apis/youtube';

class App extends React.Component {
    state = {selectedVideo: null };

    onTermSubmit = async (year,venue,session) => {
        //api call to get playlistId
       console.log("searching for: "+ venue+" "+session+" "+year)
        const response = await youtube.get('/search', {
            params: {
                q: venue+" "+session+" "+year,
                channelId: "UCB_qr75-ydFVKSF9Dmo6izg" //Official FORMULA 1 Channel ID
            }
        });
        console.log({ 'response: ': response.data });
        if (response.data.items.length === 0) {
            //clearing video selection if no playlist found
            console.log("no videos found!")
            this.setState({
                selectedVideo: null
            });
        } else {
            console.log("videos found!!")
            this.setState({
                selectedVideo: response.data.items[0]
            });
            // console.log({responsePlaylist})
        }

    };

    onVideoSelect = (video) => {
        //  console.log("selected video:",video);
        this.setState({ selectedVideo: video });
    };

    render() {
        return (
            <div className="ui container" style={{ marginTop: '10px' }}>
                <div className="ui grid">
                    <div className="ui row">
                        <div className="ui icon message">
                            <i className="car icon"></i>
                            <div className="content">
                                <div className="header">
                                    Spoiler Free F1 Highlights
                                </div>
                                <p>Search through current Formula 1 races and their highlights while
                                    avoiding spoilers in the title, thumbnail, description, and recommended videos.
                                    This is still very early development and I will be adding future races, previous years and
                                    more accurate results in the future. 
                                </p>
                                <SearchTab runWhenSubmited={this.onTermSubmit}></SearchTab>
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>
                <div className="ui grid">
                    <div className="ui row">
                            <VideoDetail video={this.state.selectedVideo}></VideoDetail>
                    </div>
                </div>
            </div>
        )
    }
}

export default App;